import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ProjectOutlinedSvg from "@ant-design/icons-svg/es/asn/ProjectOutlined";
import AntdIcon from "../components/AntdIcon";
var ProjectOutlined = function ProjectOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ProjectOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ProjectOutlined.displayName = 'ProjectOutlined';
}
export default /*#__PURE__*/React.forwardRef(ProjectOutlined);